import { Cell, Legend, Pie, PieChart, ResponsiveContainer } from 'recharts';
import { Card, Col, Row } from 'antd';

import { SummaryChartData, useGetSummaryChartDataQuery } from './api/analyticsApiSlice';

interface SummaryChartProps {
    from: string;
    to: string;
}

export function SummaryChart({ from, to }: SummaryChartProps) {
    const { data } = useGetSummaryChartDataQuery({ from, to });

    if (!data) {
        return null;
    }

    return (
        <Card>
            <Row justify="center" align="middle">
                <Col>
                    <ResponsiveContainer minWidth={350} minHeight={300}>
                        <PieChart>
                            <Legend iconType="circle" />
                            <Pie
                                label={true}
                                labelLine={false}
                                data={data}
                                innerRadius={80}
                                outerRadius={100}
                                paddingAngle={2}
                                animationDuration={500}
                                animationEasing="ease-in-out"
                            >
                                {data.map((item: SummaryChartData) => (
                                    <Cell key={item.name} fill={item.color} />
                                ))}
                            </Pie>
                        </PieChart>
                    </ResponsiveContainer>
                </Col>
            </Row>
        </Card>
    )
}